import { HexColorCode, ImageUrlMap } from './common';
import { ISODateTime } from '../../admin/types/date';
import { Coach } from './coach';
import { SheLocation } from './location';
import { Service } from '../../commonv3/types/service';
import { VideoRef } from '../../commonv3/types/block';
import { MembershipPlanGroupKey } from '../../mainv3/types/membershipPlans';

export type EventId = number;

/**
 * イベント自体の状態
 * TODO: is_full と live_casting が重複しうるので要件の確認が必要
 */
export type EventStatus =
  /** すでに終了したイベント */
  | 'is_past'
  /** 満員のイベント（開催前） */
  | 'is_full'
  /** 開催前（予約可能） */
  | 'is_upcoming'
  /** 開催中（動画配信あり） */
  | 'live_casting'
  /** アーカイブ提供中 */
  | 'archived';

/**
 * イベントに対するユーザーの状態
 * フロントで生成しているが、サーバ側から返せるようにしても良いかもしれない
 */
export type UserEventReservationStatus = {
  eventId: EventId;
  reserved: boolean;
  hasAffordableTokenForNow: boolean;
  hasAffordableTokenForEventStartAt: boolean;
};

/* eslint-disable */
export enum EventVisibleStatus {
  ACTIVE = 'active',
  LINK_ONLY = 'link_only',
  HIDDEN = 'hidden',
}

export enum EventChargeScope {
  NON_MEMBERS = 'non_members',
  ALL_USERS = 'all_users',
}
/* eslint-enable */

export type EventDetails = {
  id: EventId;
  title: string;
  sub_title: string;
  location: SheLocation;
  key_color: HexColorCode;
  highlight: string;
  introduction: string;
  target_description: string;
  cover_photo_url: ImageUrlMap;
  thumbnail_photo_url: ImageUrlMap;
  price: number;
  price_with_tax: number;
  applied_price: number;
  applied_payment_type: 'credit_card' | 'token';
  applied_price_with_tax: number;
  note: string;
  capacity: number;
  status: EventVisibleStatus;
  charge_scope: EventChargeScope;
  active_reservation_count: number;
  coaches: Coach[];
  starts_at: ISODateTime;
  ends_at: ISODateTime;
  full: boolean;
  /** @Deprecated membership_plan_group_keys を使用してください */
  service: Service;
  has_archive: boolean;
  archive_video: VideoRef;
  membership_plan_group_keys: MembershipPlanGroupKey[];
};
